import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "form-group" }
const _hoisted_2 = ["for"]
const _hoisted_3 = {
  key: 1,
  class: "field-description"
}
const _hoisted_4 = {
  key: 2,
  class: "form-error"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _renderSlot(_ctx.$slots, "default"),
    ($props.label)
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          for: $props.for,
          class: "floating-label"
        }, _toDisplayString($props.label), 9 /* TEXT, PROPS */, _hoisted_2))
      : _createCommentVNode("v-if", true),
    ($props.description)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString($props.description), 1 /* TEXT */))
      : _createCommentVNode("v-if", true),
    ($props.error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString($props.error), 1 /* TEXT */))
      : _createCommentVNode("v-if", true)
  ]))
}